import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";
import { encodeAndStoreData } from "../config/encodelocalstorage";
import { searchTopicdetail } from "../config/searchingdata";
import ModalConfig from "../modal/modalConfig";
import { Icon } from "@iconify/react";

const Residenthome = () => {
  let cookies = new Cookies();
  let navigat = useNavigate();
  const [searchtext, setSearchtext] = useState();
  const [contentSearchlink, setContentSearchlink] = useState();

  let docGetid = (id) => {
    return document.getElementById(id);
  };

  function settingDatadetailTopic() {
    const objectMajorOperation = [
      { topic: "phaco", status: "EPA", status_point: "4", req: "0" },
      { topic: "ECCE", status: "EPA", status_point: "2", req: "0" },
      { topic: "Trabe culectomy", status: "DOP", status_point: "0", req: "0" },
      {
        topic: "lidplasty,prosis",
        status: "normal",
        status_point: "0",
        req: "0",
      },
      { topic: "repair eyelid", status: "normal", status_point: "0", req: "0" },
      { topic: "Enucleation", status: "normal", status_point: "0", req: "0" },
      { topic: "Exhnocular", status: "normal", status_point: "0", req: "0" },
      { topic: "Probing NLDO", status: "normal", status_point: "0", req: "0" },
      {
        topic: "Ptevygium graft",
        status: "normal",
        status_point: "0",
        req: "0",
      },
      { topic: "Assist PK.", status: "normal", status_point: "0", req: "0" },
      {
        topic: "Assist PPV scleml buckling",
        status: "normal",
        status_point: "0",
        req: "0",
      },
      {
        topic: "repair mpture gloke",
        status: "normal",
        status_point: "0",
        req: "0",
      },
      {
        topic: "repair canclini",
        status: "normal",
        status_point: "0",
        req: "0",
      },
    ];

    const objectMinorOperation = [
      {
        topic: "Retrobulbar / peribulbar",
        status: "normal",
        status_point: "0",
        req: "0",
      },
      {
        topic: "Tarsorrhaphy(Permanant/temporal)",
        status: "normal",
        status_point: "0",
        req: "0",
      },
      { topic: "corneal scraping", status: "DOP", status_point: "0", req: "0" },
      {
        topic: "AC para cetesis",
        status: "normal",
        status_point: "0",
        req: "0",
      },
      {
        topic: "Inter clear tapping",
        status: "normal",
        status_point: "0",
        req: "0",
      },
    ];

    const objectInvestigation = [
      { topic: "VF", status: "normal", status_point: "0", req: "0" },
      { topic: "CT & MRI", status: "normal", status_point: "0", req: "0" },
      { topic: "retino scopy", status: "normal", status_point: "0", req: "0" },
      { topic: "lenso metry", status: "normal", status_point: "0", req: "0" },
      { topic: "keratometry", status: "normal", status_point: "0", req: "0" },
      { topic: "CL fitting", status: "normal", status_point: "0", req: "0" },
      { topic: "low vision", status: "normal", status_point: "0", req: "0" },
    ];

    const objectLaserprocedure = [
      {
        topic: "laser cupsulotomy",
        status: "normal",
        status_point: "0",
        req: "0",
      },
      { topic: "laser P1", status: "normal", status_point: "0", req: "0" },
      { topic: "PRP", status: "normal", status_point: "0", req: "0" },
      { topic: "laser retinopexy", status: "DOP", status_point: "0", req: "0" },
      { topic: "other", status: "normal", status_point: "0", req: "0" },
    ];

    encodeAndStoreData("dataMajor", objectMajorOperation);
    encodeAndStoreData("dataMinor", objectMinorOperation);
    encodeAndStoreData("dataInvest", objectInvestigation);
    encodeAndStoreData("dataLaser", objectLaserprocedure);
  }

  function handleClickTopiccard(id, topic) {
    docGetid(id).style.animation = "fillLoadingBar 0.25s linear normal";
    setTimeout(() => {
      navigat(`/listmenu_topic/${topic}`);
    }, 250);
  }

  function handleOpenModalLinkmessage(mode) {
    if (mode) {
      docGetid("show-search-link").style.display = "block";
    } else {
      docGetid("show-search-link").style.display = "none";
    }
  }

  function contentModalshowsearchlink() {
    const result = searchTopicdetail(searchtext);
    if (contentSearchlink) {
      return (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            navigat(`/${result.url}`);
          }}
        >
          <div className="this-message-showsearchlink">
            <div className="infoshow-showsearchlink">
              <div className="box-icon-showinfo-showsearchlink">
                <div className="abox-circle-boricon">
                  <div className="abox-circle-boricon-before">
                    <div className="icon-linkshowinfo">
                      <Icon icon="octicon:file-symlink-file-24" />
                    </div>
                  </div>
                </div>
                <div className="abox-close-showsearchlink">
                  <button
                    type="button"
                    className="btn-close-showsearchlink"
                    onClick={() => {
                      handleOpenModalLinkmessage(false);
                    }}
                  >
                    <Icon icon="fa:close" />
                  </button>
                </div>
              </div>
              <div className="box-info-showinfo-showsearchlink">
                <div className="aSpan-infoshow-showsearchlink">
                  <div>
                    <span>{`ไปยังหน้าเมนู`}</span>
                  </div>
                  <div>
                    <span>{result ? result.search : ""}</span>
                  </div>
                </div>
                <button type="submit" className="btn-tryContinue">
                  {"เปิดไปยังหน้าเมนู"}
                </button>
              </div>
            </div>
          </div>
        </form>
      );
    } else {
      return (
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleOpenModalLinkmessage(false);
          }}
        >
          <div className="this-message-showsearchlink">
            <div className="infoshow-showsearchlink">
              <div className="box-icon-showinfo-showsearchlink">
                <div
                  className="abox-circle-boricon"
                  style={{ border: "2px solid #e51c23" }}
                >
                  <div
                    className="abox-circle-boricon-before"
                    style={{
                      backgroundColor: "#F898A4",
                      border: "2px solid #e51c23",
                    }}
                  >
                    <div
                      className="icon-linkshowinfo"
                      style={{ color: "#e51c23" }}
                    >
                      <Icon icon="octicon:file-symlink-file-24" />
                    </div>
                  </div>
                </div>
                <div className="abox-close-showsearchlink">
                  <button
                    type="button"
                    className="btn-close-showsearchlink"
                    onClick={() => {
                      handleOpenModalLinkmessage(false);
                    }}
                    style={{ color: "#e51c23" }}
                  >
                    <Icon icon="fa:close" />
                  </button>
                </div>
              </div>
              <div className="box-info-showinfo-showsearchlink">
                <div className="aSpan-infoshow-showsearchlink">
                  <div>
                    <span
                      style={{ color: "#75464A" }}
                    >{`ไม่พบหน้าเมนูที่ค้นหา`}</span>
                  </div>
                </div>
                {/* <span className="aSpan-infoshow-showsearchlink">{`${
                  result ? result.search : ""
                }`}</span> */}
                <button
                  type="submit"
                  className="btn-tryContinue"
                  style={{ backgroundColor: "#F898A4" }}
                >
                  {"กลับไปค้นหาใหม่อีกครั้ง"}
                </button>
              </div>
            </div>
          </div>
        </form>
      );
    }
  }

  function handleSubmitSearchTopic(e) {
    e.preventDefault();
    const complete = searchTopicdetail(searchtext);
    if (complete.search) {
      handleOpenModalLinkmessage(true);
      setContentSearchlink(true);
    } else {
      handleOpenModalLinkmessage(true);
      setContentSearchlink(false);
    }
  }

  useEffect(() => {
    settingDatadetailTopic();
  }, []);

  return (
    <div className="body-residenthome">
      <div className="nav-residenthome">
        <div className="title-residenthome">
          <span>{`LOGBOOK`}</span>
        </div>
        <div className="search-residenthome">
          <form
            onSubmit={(e) => {
              handleSubmitSearchTopic(e);
            }}
          >
            <div className="box-search-residenthome">
              <div className="search-inputbtnbox-residenthome">
                <input
                  type="text"
                  className="input-search-residenthome"
                  onChange={(e) => {
                    setSearchtext(e.target.value);
                  }}
                  onClick={(e) => {
                    e.target.select();
                  }}
                  placeholder="search"
                ></input>
                <button type="button" className="btn-search-residenthome">
                  <i className="bi-search"></i>
                </button>
                <button type="submit" style={{ display: "none" }}></button>
              </div>
              {/* <div className="drop-searchinfoTopic"></div> */}
            </div>
          </form>
        </div>
      </div>
      <div className="contentbody-residenthome">
        <div
          className="card-content-residenthome"
          onClick={() => {
            handleClickTopiccard("majorTopiccard", "major operation");
          }}
        >
          <div className="topic-card-residenthome">
            <div className="loading-topic-residenthome" id="majorTopiccard">
              <div className="cardtopic-topic-residenthome">
                <span>{`major operation`}</span>
              </div>
              <div className="cardtopic-arrow-residenthome">
                <i className="bi-chevron-right icon-rightArrow"></i>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card-content-residenthome"
          onClick={() => {
            handleClickTopiccard("minorTopiccard", "minor operation");
          }}
        >
          <div className="topic-card-residenthome">
            <div className="loading-topic-residenthome" id="minorTopiccard">
              <div className="cardtopic-topic-residenthome">
                <span>{`minor operation`}</span>
              </div>
              <div className="cardtopic-arrow-residenthome">
                <i className="bi-chevron-right icon-rightArrow"></i>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card-content-residenthome"
          onClick={() => {
            handleClickTopiccard("investigationTopiccard", "investigation");
          }}
        >
          <div className="topic-card-residenthome">
            <div
              className="loading-topic-residenthome"
              id="investigationTopiccard"
            >
              <div className="cardtopic-topic-residenthome">
                <span>{`investigation`}</span>
              </div>
              <div className="cardtopic-arrow-residenthome">
                <i className="bi-chevron-right icon-rightArrow"></i>
              </div>
            </div>
          </div>
        </div>
        <div
          className="card-content-residenthome"
          onClick={() => {
            handleClickTopiccard("laserprocedureTopiccard", "laser procedure");
          }}
        >
          <div className="topic-card-residenthome">
            <div
              className="loading-topic-residenthome"
              id="laserprocedureTopiccard"
            >
              <div className="cardtopic-topic-residenthome">
                <span>{`laser procedure`}</span>
              </div>
              <div className="cardtopic-arrow-residenthome">
                <i className="bi-chevron-right icon-rightArrow"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-residenthome">
        <div className="box-relative"></div>
        <div className="box-relative"></div>
        <div className="box-relative"></div>
        <div className="box-relative">
          <i
            className="icon-footer-nav bi-box-arrow-left"
            onClick={() => {
              Swal.fire({
                title: "ออกจากระบบ!",
                text: "ต้องการออกจากระบบ ใช่ หรือ ไม่ ?",
                showCancelButton: true,
                showConfirmButton: true,
                confirmButtonText: "ตกลง",
                cancelButtonText: "ยกเลิก",
                icon: "warning",
              }).then((res) => {
                if (res.isConfirmed) {
                  navigat("/");
                  localStorage.removeItem("filterWork");
                  localStorage.clear();
                  cookies.remove("tokenEstimate", {
                    path: "/",
                  });
                }
              });
            }}
          ></i>
        </div>
      </div>
      <ModalConfig
        idbox="show-search-link"
        width="300px"
        height="350px"
        title="ผลการค้นหา"
        content={contentModalshowsearchlink()}
      ></ModalConfig>
    </div>
  );
};
export default Residenthome;
